<template>
  <v-layout>
    <v-flex xs12>
      <business-trip-request-form :title="title" v-model="request" refreshable
                                  @close="close" @save="save" @refresh="refresh" @input="change" v-if="loaded" />
      <v-card v-else>
        <v-card-text><h2>Loading...</h2></v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import BusinessTripRequestForm from './BusinessTripRequestForm'
import Promise from 'promise-polyfill'
import _ from 'lodash'

import Vuex from 'vuex'

const btRequestStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  name: 'business-trip-request-new',
  components: {
    BusinessTripRequestForm
  },
  data () {
    return {
      title: 'New Business Trip Request',
      request: {},
      loaded: false,
      modified: false
    }
  },
  methods: {
    ...btRequestStore.mapActions({
      getNewRequest: 'getNewRequest',
      addRequest: 'addRequest'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this
      const resources = [self.getNewRequest({vueinstance: self})]
      Promise.all(resources)
        .then(res => {
          self.request = _.cloneDeep(res[0])
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    close () {
      const self = this
      if (!self.modified) {
        this.$router.push({name: 'business-trip-request-list'})
      } else {
        const yesHandler = () => {
          this.$router.push({name: 'business-trip-request-list'})
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        self.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. Business Trip Request ' + this.request.batchNo + ' will not saved.',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      }
    },
    save (request) {
      const self = this

      if (request.documentState === 'SUBMITTED') {
        self.showConfirmation({
          title: 'Needs to add employees before submitting Business Trip Request. Please change Document State as DRAFTED to continue',
          message: '',
          buttons: [{label: 'OK', handler: () => self.closeConfirmation()}]
        })
      } else {
        this.$store.dispatch('Action/setLoading', true)
        self.addRequest({vueinstance: self, sppd: request})
          .then(res => {
            this.$store.dispatch('Action/setLoading', false)
            self.loaded = false
            self.request = _.cloneDeep(res)
            self.loaded = true
            // redirect to newly saved btrequest page
            self.$router.replace({name: 'business-trip-request-detail', params: {id: self.request.id}})
            self.$success('New Business Trip Request Saved: ' + self.request.batchNo)
            self.modified = false
          })
          .catch(err => {
            this.$store.dispatch('Action/setLoading', false)
            self.$error(err)
          })
      }
    },
    refresh () {
      const self = this
      self.loaded = false
      self.modified = false

      self.loadResources()
    },
    change (request) {
      this.modified = true
    }
  },
  mounted () {
    this.loadResources()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestNew.vue